import { toMillis } from './to-millis';

// structural sharing stops at Date fields, so an unchanged doc would still be a new object
export const keepIdentityWhenUnchanged = <T>(
  existing: T | undefined,
  incoming: T,
): T => {
  const existingMillis = toMillis(
    (existing as { updatedAt?: unknown } | undefined)?.updatedAt,
  );
  const incomingMillis = toMillis(
    (incoming as { updatedAt?: unknown } | null | undefined)?.updatedAt,
  );
  const unchanged =
    existing !== undefined &&
    existingMillis !== null &&
    existingMillis === incomingMillis;
  return unchanged ? existing : incoming;
};
